// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"149":"eaa7969c13b08130","861":"d83adc1487ee7322","954":"ca4a744199734121"}[chunkId] + ".js";
};